import React from 'react';
import { SearchOutlined } from '@mui/icons-material';
import { TextField } from '@mui/material';

export const ColumnPanelSearch = ({ setSearch }) => {
  return (
    <TextField
      hiddenLabel
      placeholder="Search"
      variant="outlined"
      type="search"
      onChange={e => setSearch(e.target.value)}
      sx={{
        '.MuiInputBase-root': {
          pl: 1.5,
          pr: 1
        },
        p: '12px 24px'
      }}
      slotProps={{
        input: {
          startAdornment: <SearchOutlined sx={{ color: '#757575' }} />
        }
      }}
    />
  );
};
